import { render } from "./GoogleSigninButton.vue?vue&type=template&id=57b852b5&scoped=true&ts=true"
import script from "./GoogleSigninButton.ts?vue&type=script&lang=ts&external"
export * from "./GoogleSigninButton.ts?vue&type=script&lang=ts&external"

import "./GoogleSigninButton.scss?vue&type=style&index=0&id=57b852b5&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b852b5"]])

export default __exports__